import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import Fr_Input from "../../../lib/ui/fr_input";
import Dd_Sel from "../../../lib/ui/dd_sel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Rv_Kk extends React.Component {
  constructor(props, context) {
    super(props);

    this.selitems = [
        {fkn: 'bevaka', text: 'BEVAKA'},
        {fkn: 'bokbild', text: 'BOKNINGSBILD'},
        {fkn: 'confirm', text: 'BEKRÄFTA'},
        {fkn: 'cancel', text: 'AVBOKA'}
    ];

    this.store = props.store;
    this.state = {};
    this.state.ynq = [];
    //this.state.vga = [];
    this.state.rta = [];
    this.state.bra = [];

    this.state.bgo = {};
    this.state.cols = {};

    this.state.ix = 0;
    this.state.boknr = "";
    if(props.boknr) this.state.boknr = props.boknr;

    this.state.rvo = {};
    this.state.rvo.nrr = "1";
    this.state.rvo.sum = "2000";
    this.state.rvo.rvo = {};

    this.state.kro = {};
    this.state.kro.krr00 = {};
    this.state.kro.krr01 = {};
    this.state.kro.krr02 = {};
    this.state.kro.krr03 = {};
    
    if(props.wnds) {
        if(props.wnds.boknr) this.state.boknr = props.wnds.boknr;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //this.brs();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }
    rsv_anm_change (e) {
      const name = e.target.name;
      const value = e.target.value;
      var rsv = this.state.rsv;
      var na = name.split(".");
      rsv[na[0]][na[1]] = value;
      this.setState({rsv: rsv});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    drag(event) {
        //event.dataTransfer.setData("text", event.target.id);
	};
    drop(event) {
        event.preventDefault();
        alert("Drop");
	};
    dragEnter(event) {
        event.preventDefault();
        event.target.style.color = "#fff";
        event.target.style.background = "#ccc";
        //alert("Allow Drop");
	};
    dragLeave(event) {
        event.preventDefault();
        event.target.style.color = "#fff";
        event.target.style.background = "#080";
        //alert("Allow Drop");
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };
  mnu_toggle() {
    //props.ctx.setState({ mnu_show: !props.ctx.state.mnu_show });
    //props.store.cfg.mnu_show = !props.store.cfg.mnu_show;
  };
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }
  sel_fkn(sel) {
    //alert(JSON.stringify(fkn));
      if(sel.fkn == "logout") {
      }
  }
  brs() {
    var self = this;

    var prm = {};
    prm.req = "pms.br.bra";
    prm.boknr = this.state.boknr;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({bra: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    return;
  }
  kk() {
    var self = this;

    return;
    var prm = {};
    prm.req = "pos.pos_plu.plu_bufsave";
    prm.fkn = "7221";
    prm.boknr = this.state.boknr;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({gsa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    return;
  }

  render() {
    //if(!this.props.show) return "";

    //alert(this.props.ctx.state.lro);

    var title = this.props.title;
    if(!title) title = "Bokning";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_h01">
            <div>KUNDKORT</div>
        </div>
        <div className="mx_content flex">

        <div className="flex-row py-1 px-2">
                <div className="txt_12 web_mnu_head" onClick={() => this.kk() }>KUNDKORT</div>
                <div className="flex"></div>
                <div className="flex"></div>
                <div className="txt_12 web_mnu_link" onClick={() => this.kk() }>UPPDATERA</div>
      </div>
      <div className="divider_green"></div>
       <form className="cdi_f03">
                        <div className="flex-row">
                            <Fr_Input label="Företag" className="text-left w350" text={this.state.kro.krr00.company} getValue={(e)=> this.val_save("krr00.company", e) } />
                            <Fr_Input label="Orgnr" className="text-left w250" text={this.state.kro.krr02.orgnr} getValue={(e)=> this.val_save("krr02.orgnr", e) } />
                        </div>
                        <div className="flex-row">
                            <Fr_Input label="Namn" className="text-left w350" text={this.state.kro.krr00.namn} getValue={(e)=> this.val_save("krr00.namn", e) } />
                        </div>
                        <div className="divider_green"></div>
                        <div className="flex-row">
                            <Fr_Input label="Email" className="text-left w450" text={this.state.kro.krr03.email} getValue={(e)=> this.val_save("krr03.email", e) } />
                        </div>
                        <div className="flex-row">
                            <Fr_Input label="Postadress" className="text-left w250" text={this.state.kro.krr01.adress1} getValue={(e)=> this.val_save("krr01.adress1", e) } />
                            <Fr_Input label="Telefon" className="text-left w250" text={this.state.kro.krr03.tfn} getValue={(e)=> this.val_save("krr03.tfn", e) } />
                        </div>
                        <div className="flex-row">
                            <Fr_Input label="Gatuadress" className="text-left w350" text={this.state.kro.krr01.adress2} getValue={(e)=> this.val_save("krr01.adress2", e) } />
                            <Fr_Input label="Mobil" className="text-left w250" text={this.state.kro.krr03.mobil} getValue={(e)=> this.val_save("krr03.mobil", e) } />
                        </div>
                        <div className="flex-row">
                            <Fr_Input label="Postnr" className="text-left w150" text={this.state.kro.krr02.postnr} getValue={(e)=> this.val_save("krr02.postnr", e) } />
                            <Fr_Input label="Ort" className="text-left w250" text={this.state.kro.krr02.city} getValue={(e)=> this.val_save("krr02.city", e) } />
                        </div>
                        <div className="flex-row">
                            <Fr_Input label="Land" className="text-left w350" text={this.state.kro.krr02.land} getValue={(e)=> this.val_save("krr02.land", e) } />
                        </div>
        </form>
        <div className="divider_green"></div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            <Dd_Sel items={ this.selitems } getValue={(e)=> this.sel_fkn(e)} />
            </div>
            <button className="btn btn-hw-green w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
        </div>
      </div>
    </div>
	;
	return html;
  };
}

export default Rv_Kk;